import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ErrorAlertIcon } from '../../../../assets/icons/layout-icons/ErrorAlertIcon.svg';
import { ReactComponent as BriefcaseCheckIcon } from '../../../../assets/icons/layout-icons/BriefcaseCheckIcon.svg';
import { ReactComponent as CancelIcon } from '../../../../assets/icons/project-icons/CancelCircleIcon.svg';
import { ReactComponent as BriefcaseMagnifierIcon } from '../../../../assets/icons/layout-icons/BriefcaseMagnifierIcon.svg';
import { primaryLight, secondaryBlue, secondaryPink } from '../../../../utils/color';
import ConfirmModal from '../../../../components/confirm-modal/ConfirmModal';
import CustomReferenceField from '../../../../components/custom-fields/CustomReferenceField';
import { TimedProjectCreateModalProps } from '../interface';

const TimedProjectCreateModal = ({
  isOpen,
  setIsOpen,
  type,
  errorMessage,
  onConfirm,
  timedProject,
}: TimedProjectCreateModalProps) => {
  const { t } = useTranslation();
  const modalsContent = {
    create: {
      title: t('tenders.modals.create.title'),
      text: t('tenders.modals.create.text'),
      icon: <BriefcaseMagnifierIcon fill={secondaryBlue[700]} />,
      wrapperBackgroundColor: primaryLight[100],
    },
    edit: {
      title: t('tenders.modals.edit.title'),
      text: t('tenders.modals.edit.text'),
      icon: <BriefcaseCheckIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: secondaryBlue[100],
    },
    draft: {
      title: t('tenders.modals.draft.title'),
      text: t('tenders.modals.draft.text'),
      icon: <BriefcaseCheckIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: secondaryBlue[100],
    },
    error: {
      title: t('tenders.modals.error.title'),
      text: t('tenders.modals.error.text'),
      icon: <ErrorAlertIcon fill={secondaryPink[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: secondaryPink[100],
    },
    cancel: {
      title: t('tenders.modals.cancel.title'),
      text: t('tenders.modals.cancel.text'),
      icon: <CancelIcon fill={secondaryBlue[700]} style={{ width: 24, height: 24 }} />,
      wrapperBackgroundColor: secondaryBlue[100],
    },
  };

  const message = errorMessage || modalsContent[type].text;
  const navigate = useNavigate();
  const confirm = onConfirm || (() => navigate('../'));

  return (
    <ConfirmModal
      width="50%"
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      title={modalsContent[type].title}
      message={
        <Typography color="primaryDark.500" lineHeight="21px">
          {message}
        </Typography>
      }
      confirmButtonText={
        type === 'draft'
          ? t('common.confirm')
          : type === 'cancel'
          ? t('common.proceed')
          : t('common.close')
      }
      onConfirm={confirm}
      iconProps={{
        icon: modalsContent[type].icon,
        wrapperBackgroundColor: modalsContent[type].wrapperBackgroundColor,
      }}
      showCancelButton={type === 'draft' || type === 'cancel'}
      onCancel={() => setIsOpen(false)}
    />
  );
};

export default TimedProjectCreateModal;
